// src/pages/Admin.jsx or similar
import React from "react";

const Admin = () => {

  // Check for auth code in URL
  const urlParams = new URLSearchParams(window.location.search);
  const authCode = urlParams.get("code");

  return (
    <div style={{ padding: "2rem" }}>
      <h1>Facebook Token Refresher</h1>


      <p>Go to facebook, login with wichi M0fa</p>
      Go to https://developers.facebook.com/docs/graph-api/

      Click on apps, click on app (wichibot-social), click on dashboard
      <br />go to tools/api explorer
      <br />copy access Token
      <br />tools/access token debugger
      <br />extend access token
      <br />paste access token, set expiration to 58 days
      <br />inspector:
      <br />const today = new Date();
      <br />const futureDate = new Date(today);
      <br />futureDate.setDate(today.getDate() + 58);
      <br />console.log(futureDate.toDateString());

    </div>
  );
};

export default Admin;
